import {
	EditOutlined,
	NotificationOutlined,
	QuestionCircleOutlined,
	WarningOutlined,
} from "@ant-design/icons";
import React, { useContext, useState } from "react";

import { ConfigStateContext } from "../../../shared-components/Contexts/Configurations/context";
import { Form } from "antd";
import { Rule } from "antd/lib/form";

export const useContact = () => {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const { main_domain, site_name } = useContext(ConfigStateContext);
	const [formCompleted, setFormCompleted] = useState(false);

	const SEND_LEAD_URL: string = `https://${main_domain}/sitio/index.php?mid=contacto&func=doContacto`;

	const dataSectionHelp = [
		{
			id: 1,
			desc: "Dudas acerca del sistema",
			icon: <QuestionCircleOutlined />,
		},
		{
			id: 2,
			desc: "Quiero publicar y no sé cómo",
			icon: <EditOutlined />,
		},
		{
			id: 3,
			desc: "Fraudes electrónicos",
			icon: <WarningOutlined />,
		},
		{
			id: 4,
			desc: "Denunciar un problema",
			icon: <NotificationOutlined />,
		},
	];

	const dataSectionFAQs = [
		{
			id: 1,
			desc:
				"En el lado superior derecho de cada ficha de propiedad, encontrarás la opción de realizar denuncias sobre la publicación o el anunciante.",
			img:
				site_name == "InfoCasas"
					? "https://cdn4.fincaraiz.com.co/web/59a4786b12271_infocdn__cuadro-contacto-ic-denuncia.png"
					: "https://cdn2.casaseneleste.com/web/599af76a88e66_infocdn__img-laptop.png",
			alt: "IC-Denuncia",
		},
		{
			id: 2,
			desc:
				"Todos los instructivos sobre el funcionamiento del sitio y problemas más frecuentes, se encuentran bien explicados en nuestras FAQs.",
			img:
				site_name == "InfoCasas"
					? "https://cdn4.fincaraiz.com.co/web/59a478b747f06_infocdn__cuadro-contacto-ic-instructivo.png"
					: "https://cdn2.casaseneleste.com/web/599af7530d978_infocdn__img-instructivo.png",
			alt: "IC-Instructivo",
		},
	];

	const validateMessages = {
		required: "Este campo es requerido!",
		types: {
			email: "El email ingresado no es valido!",
			number: "El teléfono no es un numero valido!",
		},
	};

	const validateRules: { [x: string]: Rule[] } = {
		nombre: [{ required: true }],
		telefono: [
			{ required: true },
			{
				pattern: new RegExp("^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$"),
				message: "Teléfono no válido",
			},
		],
		email: [{ required: true, type: "email" }],
		consulta: [{ required: true }],
	};

	const submitForm = () => {
		form.validateFields().then(async values => {
			setLoading(true);
			if (SEND_LEAD_URL != "") {
				values.ticket = 1;
				await fetch(SEND_LEAD_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
					},
					body: new URLSearchParams(values),
				})
					.then(response => {
						setLoading(false);
						setFormCompleted(true);
						handleClickShowNotification({
							message: "¡Su consulta fue enviada. Nos pondremos en contacto a la brevedad.!",
						});
						return response;
					})
					.catch(err => {
						setFormCompleted(false);
						console.error("Contact form submit failed", err);
						handleClickShowNotification({
							message: "Ha ocurrido un error",
							description: "Hubo un error. Vuelva a intentarlo.",
							type: "error",
						});
						return "error";
					});
			}
		});
	};

	return {
		form: form,
		submitForm: submitForm,
		validateRules: validateRules,
		loading: { loading, setLoading },
		validateMessages: validateMessages,
		data: { dataSectionHelp, dataSectionFAQs },
		formCompleted: { formCompleted, setFormCompleted },
	};
};
